import { apiPaths, apiActions } from "./db"

export const enumRoles = { ADMIN: 1, MANAGER: 2, ADVERTISER: 3, AFFILIATE: 4, SUPPORT: 5, FINANCE: 6, BAN: 99 }

const enumPermissionActions = { ...apiActions }
const EPA = enumPermissionActions

export const enumPermissionModules = { ...apiPaths }
const EPM = enumPermissionModules

export const enumPermissions = {
  //Admin - Dashboard
  ADMIN_DASHBOARD_ANALYTICS: `${EPM.ADMIN_DASHBOARD}/${EPA.ANALYTICS}`,
  // Admin report
  ADMIN_REPORT_BALANCE: `${EPM.ADMIN_REPORT}/${EPA.BALANCE}`,
  ADMIN_REPORT_OFFERS: `${EPM.ADMIN_REPORT}/${EPA.OFFERS}`,
  ADMIN_REPORT_USERS: `${EPM.ADMIN_REPORT}/${EPA.USERS}`,
  ADMIN_REPORT_ADVERTISERS: `${EPM.ADMIN_REPORT}/${EPA.ADVERTISERS}`,
  ADMIN_REPORT_COUNTRIES: `${EPM.ADMIN_REPORT}/${EPA.COUNTRIES}`,
  ADMIN_REPORT_DYNAMICS: `${EPM.ADMIN_REPORT}/${EPA.DYNAMICS}`,
  ADMIN_REPORT_ORDERS: `${EPM.ADMIN_REPORT}/${EPA.ORDERS}`,
  // Admin - Users
  ADMIN_USERS_LIST: `${EPM.ADMIN_USERS}/${EPA.LIST}`,
  ADMIN_USERS_GET: `${EPM.ADMIN_USERS}/${EPA.GET}`,
  ADMIN_USERS_CREATE: `${EPM.ADMIN_USERS}/${EPA.CREATE}`,
  ADMIN_USERS_UPDATE: `${EPM.ADMIN_USERS}/${EPA.UPDATE}`,
  ADMIN_USERS_UPDATE_EMAIL: `${EPM.ADMIN_USERS}/${EPA.UPDATE_EMAIL}`,
  ADMIN_USERS_DELETE: `${EPM.ADMIN_USERS}/${EPA.DELETE}`,
  // Admin - Users unapproved
  ADMIN_USERS_UNAPPROVED_LIST: `${EPM.ADMIN_USERS_UNAPPROVED}/${EPA.LIST}`,
  ADMIN_USERS_UNAPPROVED_APPROVED: `${EPM.ADMIN_USERS_UNAPPROVED}/${EPA.APPROVED}`,
  ADMIN_USERS_UNAPPROVED_REJECT: `${EPM.ADMIN_USERS_UNAPPROVED}/${EPA.REJECT}`,
  ADMIN_USERS_UNAPPROVED_SET_MANAGER: `${EPM.ADMIN_USERS_UNAPPROVED}/${EPA.SET_MANAGER}`,
  ADMIN_USERS_UNAPPROVED_RESET_MANAGER: `${EPM.ADMIN_USERS_UNAPPROVED}/${EPA.RESET_MANAGER}`,
  ADMIN_USERS_UNAPPROVED_TOTAL: `${EPM.ADMIN_USERS_UNAPPROVED}/${EPA.TOTAL}`,
  // Admin - fast login
  ADMIN_FAST_LOGIN_CREATE: `${EPM.ADMIN_FAST_LOGIN}/${EPA.CREATE}`,
  ADMIN_FAST_LOGIN_CHECK: `${EPM.ADMIN_FAST_LOGIN}/${EPA.CHECK}`,
  // Admin - Permissions
  ADMIN_PERMISSIONS_GET: `${EPM.ADMIN_PERMISSIONS}/${EPA.GET}`,
  ADMIN_PERMISSIONS_UPDATE: `${EPM.ADMIN_PERMISSIONS}/${EPA.UPDATE}`,
  // Admin - Domains
  ADMIN_DOMAINS_LIST: `${EPM.ADMIN_DOMAINS}/${EPA.LIST}`,
  ADMIN_DOMAINS_GET: `${EPM.ADMIN_DOMAINS}/${EPA.GET}`,
  ADMIN_DOMAINS_CREATE: `${EPM.ADMIN_DOMAINS}/${EPA.CREATE}`,
  ADMIN_DOMAINS_UPDATE: `${EPM.ADMIN_DOMAINS}/${EPA.UPDATE}`,
  ADMIN_DOMAINS_DELETE: `${EPM.ADMIN_DOMAINS}/${EPA.DELETE}`,
  // Admin - Domains
  ADMIN_NEWS_LIST: `${EPM.ADMIN_NEWS}/${EPA.LIST}`,
  ADMIN_NEWS_GET: `${EPM.ADMIN_NEWS}/${EPA.GET}`,
  ADMIN_NEWS_CREATE: `${EPM.ADMIN_NEWS}/${EPA.CREATE}`,
  ADMIN_NEWS_UPDATE: `${EPM.ADMIN_NEWS}/${EPA.UPDATE}`,
  ADMIN_NEWS_DELETE: `${EPM.ADMIN_NEWS}/${EPA.DELETE}`,
  // Admin - Prelandings
  ADMIN_PRELANDINGS_LIST: `${EPM.ADMIN_PRELANDINGS}/${EPA.LIST}`,
  ADMIN_PRELANDINGS_GET: `${EPM.ADMIN_PRELANDINGS}/${EPA.GET}`,
  ADMIN_PRELANDINGS_CREATE: `${EPM.ADMIN_PRELANDINGS}/${EPA.CREATE}`,
  ADMIN_PRELANDINGS_UPDATE: `${EPM.ADMIN_PRELANDINGS}/${EPA.UPDATE}`,
  ADMIN_PRELANDINGS_DELETE: `${EPM.ADMIN_PRELANDINGS}/${EPA.DELETE}`,
  // Admin - Topups
  ADMIN_TOPUPS_LIST: `${EPM.ADMIN_TOPUPS}/${EPA.LIST}`,
  ADMIN_TOPUPS_GET: `${EPM.ADMIN_TOPUPS}/${EPA.GET}`,
  ADMIN_TOPUPS_CREATE: `${EPM.ADMIN_TOPUPS}/${EPA.CREATE}`,
  ADMIN_TOPUPS_UPDATE: `${EPM.ADMIN_TOPUPS}/${EPA.UPDATE}`,
  ADMIN_TOPUPS_DELETE: `${EPM.ADMIN_TOPUPS}/${EPA.DELETE}`,
  // Admin - Payments
  ADMIN_PAYMENTS_LIST: `${EPM.ADMIN_PAYMENTS}/${EPA.LIST}`,
  ADMIN_PAYMENTS_CREATE: `${EPM.ADMIN_PAYMENTS}/${EPA.CREATE}`,
  ADMIN_PAYMENTS_UPDATE: `${EPM.ADMIN_PAYMENTS}/${EPA.UPDATE}`,
  ADMIN_PAYMENTS_TOTAL: `${EPM.ADMIN_PAYMENTS}/${EPA.TOTAL}`,
  ADMIN_PAYMENTS_MASS: `${EPM.ADMIN_PAYMENTS}/${EPA.MASS}`,

  // Admin - Orders
  ADMIN_ORDERS_LIST: `${EPM.ADMIN_ORDERS}/${EPA.LIST}`,
  ADMIN_ORDERS_LOGS: `${EPM.ADMIN_ORDERS}/${EPA.LOGS}`,
  ADMIN_ORDERS_UPDATE: `${EPM.ADMIN_ORDERS}/${EPA.UPDATE}`,
  ADMIN_ORDERS_COUNTER: `${EPM.ADMIN_ORDERS}/${EPA.COUNTER}`,
  ADMIN_ORDERS_VIEW_PHONE: `${EPM.ADMIN_ORDERS}/${EPA.VIEW_PHONE}`,
  // Admin - Orders Errors
  ADMIN_ORDERS_ERRORS_LIST: `${EPM.ADMIN_ORDERS_ERRORS}/${EPA.LIST}`,
  ADMIN_ORDERS_ERRORS_GET: `${EPM.ADMIN_ORDERS_ERRORS}/${EPA.GET}`,
  ADMIN_ORDERS_ERRORS_UPDATE: `${EPM.ADMIN_ORDERS_ERRORS}/${EPA.UPDATE}`,
  ADMIN_ORDERS_ERRORS_DELETE: `${EPM.ADMIN_ORDERS_ERRORS}/${EPA.DELETE}`,
  ADMIN_ORDERS_ERRORS_RESEND: `${EPM.ADMIN_ORDERS_ERRORS}/${EPA.RESEND}`,
  ADMIN_ORDERS_ERRORS_VIEW_PHONE: `${EPM.ADMIN_ORDERS_ERRORS}/${EPA.VIEW_PHONE}`,

  // Admin - Subscriptions
  ADMIN_OFFERS_SUBSCRIPTIONS_LIST: `${EPM.ADMIN_OFFERS_SUBSCRIPTIONS}/${EPA.LIST}`,
  ADMIN_OFFERS_SUBSCRIPTIONS_UPDATE: `${EPM.ADMIN_OFFERS_SUBSCRIPTIONS}/${EPA.UPDATE}`,
  ADMIN_OFFERS_SUBSCRIPTIONS_GET: `${EPM.ADMIN_OFFERS_SUBSCRIPTIONS}/${EPA.GET}`,
  ADMIN_OFFERS_SUBSCRIPTIONS_APPROVE_PAYMENT: `${EPM.ADMIN_OFFERS_SUBSCRIPTIONS}/${EPA.APPROVE_PAYMENT}`,
  ADMIN_OFFERS_SUBSCRIPTIONS_TOTAL: `${EPM.ADMIN_OFFERS_SUBSCRIPTIONS}/${EPA.TOTAL}`,
  // Admin - Offers
  ADMIN_OFFERS_LIST: `${EPM.ADMIN_OFFERS}/${EPA.LIST}`,
  ADMIN_OFFERS_GET: `${EPM.ADMIN_OFFERS}/${EPA.GET}`,
  ADMIN_OFFERS_CREATE: `${EPM.ADMIN_OFFERS}/${EPA.CREATE}`,
  ADMIN_OFFERS_UPDATE: `${EPM.ADMIN_OFFERS}/${EPA.UPDATE}`,
  ADMIN_OFFERS_DELETE: `${EPM.ADMIN_OFFERS}/${EPA.DELETE}`,
  // Admin - Offers Access
  ADMIN_OFFERS_ACCESS_LIST: `${EPM.ADMIN_OFFERS_ACCESS}/${EPA.LIST}`,
  ADMIN_OFFERS_ACCESS_CREATE: `${EPM.ADMIN_OFFERS_ACCESS}/${EPA.CREATE}`,
  ADMIN_OFFERS_ACCESS_APPROVED: `${EPM.ADMIN_OFFERS_ACCESS}/${EPA.APPROVED}`,
  ADMIN_OFFERS_ACCESS_REJECT: `${EPM.ADMIN_OFFERS_ACCESS}/${EPA.REJECT}`,
  // Admin - Offers Payout
  ADMIN_OFFERS_PAYOUT_LIST: `${EPM.ADMIN_OFFERS_PAYOUT}/${EPA.LIST}`,
  ADMIN_OFFERS_PAYOUT_GET: `${EPM.ADMIN_OFFERS_PAYOUT}/${EPA.GET}`,
  ADMIN_OFFERS_PAYOUT_CREATE: `${EPM.ADMIN_OFFERS_PAYOUT}/${EPA.CREATE}`,
  ADMIN_OFFERS_PAYOUT_UPDATE: `${EPM.ADMIN_OFFERS_PAYOUT}/${EPA.UPDATE}`,
  ADMIN_OFFERS_PAYOUT_DELETE: `${EPM.ADMIN_OFFERS_PAYOUT}/${EPA.DELETE}`,
  // Admin - Offers Blacklist Users
  ADMIN_OFFERS_BLACKLIST_USERS_LIST: `${EPM.ADMIN_OFFERS_BLACKLIST_USERS}/${EPA.LIST}`,
  ADMIN_OFFERS_BLACKLIST_USERS_CREATE: `${EPM.ADMIN_OFFERS_BLACKLIST_USERS}/${EPA.CREATE}`,
  ADMIN_OFFERS_BLACKLIST_USERS_DELETE: `${EPM.ADMIN_OFFERS_BLACKLIST_USERS}/${EPA.DELETE}`,
  // Admin - Offers Tracking List
  ADMIN_OFFERS_TRACKING_LINKS_LIST: `${EPM.ADMIN_OFFERS_TRACKING_LINKS}/${EPA.LIST}`,
  ADMIN_OFFERS_TRACKING_LINKS_CREATE: `${EPM.ADMIN_OFFERS_TRACKING_LINKS}/${EPA.CREATE}`,
  ADMIN_OFFERS_TRACKING_LINKS_DELETE: `${EPM.ADMIN_OFFERS_TRACKING_LINKS}/${EPA.DELETE}`,
  // Admin - Offers Users guarantees
  ADMIN_OFFERS_USERS_GUARANTEES_LIST: `${EPM.ADMIN_OFFERS_USERS_GUARANTEES}/${EPA.LIST}`,
  ADMIN_OFFERS_USERS_GUARANTEES_GET: `${EPM.ADMIN_OFFERS_USERS_GUARANTEES}/${EPA.GET}`,
  ADMIN_OFFERS_USERS_GUARANTEES_CREATE: `${EPM.ADMIN_OFFERS_USERS_GUARANTEES}/${EPA.CREATE}`,
  ADMIN_OFFERS_USERS_GUARANTEES_UPDATE: `${EPM.ADMIN_OFFERS_USERS_GUARANTEES}/${EPA.UPDATE}`,
  ADMIN_OFFERS_USERS_GUARANTEES_DELETE: `${EPM.ADMIN_OFFERS_USERS_GUARANTEES}/${EPA.DELETE}`,
  // Admin -  Guarantees Logs
  ADMIN_GUARANTEES_LOGS_LIST: `${EPM.ADMIN_GUARANTEES_LOGS}/${EPA.LIST}`,
  ADMIN_GUARANTEES_LOGS_GET: `${EPM.ADMIN_GUARANTEES_LOGS}/${EPA.GET}`,
  ADMIN_GUARANTEES_LOGS_CREATE: `${EPM.ADMIN_GUARANTEES_LOGS}/${EPA.CREATE}`,
  ADMIN_GUARANTEES_LOGS_UPDATE: `${EPM.ADMIN_GUARANTEES_LOGS}/${EPA.UPDATE}`,
  ADMIN_GUARANTEES_LOGS_DELETE: `${EPM.ADMIN_GUARANTEES_LOGS}/${EPA.DELETE}`,
  // Admin - Landings
  ADMIN_LANDINGS_LIST: `${EPM.ADMIN_LANDINGS}/${EPA.LIST}`,
  ADMIN_LANDINGS_GET: `${EPM.ADMIN_LANDINGS}/${EPA.GET}`,
  ADMIN_LANDINGS_CREATE: `${EPM.ADMIN_LANDINGS}/${EPA.CREATE}`,
  ADMIN_LANDINGS_UPDATE: `${EPM.ADMIN_LANDINGS}/${EPA.UPDATE}`,
  ADMIN_LANDINGS_DELETE: `${EPM.ADMIN_LANDINGS}/${EPA.DELETE}`,
  // Admin - Login History
  ADMIN_LOGIN_HISTORY_LIST: `${EPM.ADMIN_LOGIN_HISTORY}/${EPA.LIST}`,
  ADMIN_LOGIN_HISTORY_GET: `${EPM.ADMIN_LOGIN_HISTORY}/${EPA.GET}`,
  ADMIN_LOGIN_HISTORY_DELETE: `${EPM.ADMIN_LOGIN_HISTORY}/${EPA.DELETE}`,
  // Admin - Balance
  ADMIN_BALANCE_LIST: `${EPM.ADMIN_BALANCE}/${EPA.LIST}`,
  ADMIN_BALANCE_UPDATE: `${EPM.ADMIN_BALANCE}/${EPA.UPDATE}`,
  ADMIN_BALANCE_DELETE: `${EPM.ADMIN_BALANCE}/${EPA.DELETE}`,
  // Admin - Logs - Queue Email
  ADMIN_LOGS_QUEUE_EMAIL: `${EPM.ADMIN_LOGS}/${EPA.QUEUE_EMAIL}`,
  // Admin - Change-log
  ADMIN_CHANGELOG_LIST: `${EPM.ADMIN_CHANGELOG}/${EPA.LIST}`,
  ADMIN_CHANGELOG_CREATE: `${EPM.ADMIN_CHANGELOG}/${EPA.CREATE}`,
  ADMIN_CHANGELOG_DELETE: `${EPM.ADMIN_CHANGELOG}/${EPA.DELETE}`,
  ADMIN_CHANGELOG_UPDATE: `${EPM.ADMIN_CHANGELOG}/${EPA.UPDATE}`,

  //Admin - Postback logs
  ADMIN_POSTBACK_LOGS_LIST: `${EPM.ADMIN_POSTBACK_LOGS}/${EPA.LIST}`,

  ADMIN_PROFILE_GET: `${EPM.ADMIN_PROFILE}/${EPA.GET}`,
  ADMIN_PROFILE_UPDATE: `${EPM.ADMIN_PROFILE}/${EPA.UPDATE}`,


  // Admin - Country
  ADMIN_COUNTRY_LIST: `${EPM.ADMIN_COUNTRY}/${EPA.LIST}`,

}
const EP = enumPermissions

export const constructedPermissionTree = {
  [EPM.ADMIN_REPORT]: {
    original: [EPA.BALANCE, EPA.OFFERS, EPA.USERS, EPA.ADVERTISERS, EPA.COUNTRIES, EPA.DYNAMICS],
    modified: [EP.ADMIN_REPORT_BALANCE, EP.ADMIN_REPORT_OFFERS, EP.ADMIN_REPORT_USERS, EP.ADMIN_REPORT_ADVERTISERS, EP.ADMIN_REPORT_COUNTRIES, EP.ADMIN_REPORT_DYNAMICS, EP.ADMIN_REPORT_ORDERS]
  },
  [EPM.ADMIN_USERS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.UPDATE_EMAIL, EPA.DELETE],
    modified: [EP.ADMIN_USERS_LIST, EP.ADMIN_USERS_GET, EP.ADMIN_USERS_CREATE, EP.ADMIN_USERS_UPDATE, EP.ADMIN_USERS_UPDATE_EMAIL, EP.ADMIN_USERS_DELETE]
  },
  [EPM.ADMIN_PERMISSIONS]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_PERMISSIONS_GET, EP.ADMIN_PERMISSIONS_UPDATE]
  },
  [EPM.ADMIN_USERS_UNAPPROVED]: {
    original: [EPA.LIST, EPA.APPROVED, EPA.REJECT, EPA.SET_MANAGER, EPA.RESET_MANAGER, EPA.TOTAL],
    modified: [EP.ADMIN_USERS_UNAPPROVED_LIST, EP.ADMIN_USERS_UNAPPROVED_APPROVED, EP.ADMIN_USERS_UNAPPROVED_REJECT, EP.ADMIN_USERS_UNAPPROVED_SET_MANAGER, EP.ADMIN_USERS_UNAPPROVED_RESET_MANAGER, EP.ADMIN_USERS_UNAPPROVED_TOTAL]
  },
  [EPM.ADMIN_FAST_LOGIN]: {
    original: [EPA.CREATE, EPA.CHECK],
    modified: [EP.ADMIN_FAST_LOGIN_CREATE, EP.ADMIN_FAST_LOGIN_CHECK]
  },
  [EPM.ADMIN_OFFERS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_OFFERS_LIST, EP.ADMIN_OFFERS_GET, EP.ADMIN_OFFERS_CREATE, EP.ADMIN_OFFERS_UPDATE]
  },
  [EPM.ADMIN_OFFERS_SUBSCRIPTIONS]: {
    original: [EPA.LIST, EPA.GET, EPA.UPDATE, EPA.APPROVE_PAYMENT, EPA.TOTAL],
    modified: [EP.ADMIN_OFFERS_SUBSCRIPTIONS_LIST, EP.ADMIN_OFFERS_SUBSCRIPTIONS_GET, EP.ADMIN_OFFERS_SUBSCRIPTIONS_UPDATE, EP.ADMIN_OFFERS_SUBSCRIPTIONS_APPROVE_PAYMENT, EP.ADMIN_OFFERS_SUBSCRIPTIONS_TOTAL]
  },
  [EPM.ADMIN_OFFERS_ACCESS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.APPROVED, EPA.REJECT],
    modified: [EP.ADMIN_OFFERS_ACCESS_LIST, EP.ADMIN_OFFERS_ACCESS_CREATE, EP.ADMIN_OFFERS_ACCESS_APPROVED, EP.ADMIN_OFFERS_ACCESS_REJECT]
  },
  [EPM.ADMIN_OFFERS_BLACKLIST_USERS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.DELETE],
    modified: [EP.ADMIN_OFFERS_BLACKLIST_USERS_LIST, EP.ADMIN_OFFERS_BLACKLIST_USERS_CREATE, EP.ADMIN_OFFERS_BLACKLIST_USERS_DELETE]
  },
  [EPM.ADMIN_OFFERS_TRACKING_LINKS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.DELETE],
    modified: [EP.ADMIN_OFFERS_TRACKING_LINKS_LIST, EP.ADMIN_OFFERS_TRACKING_LINKS_CREATE, EP.ADMIN_OFFERS_TRACKING_LINKS_DELETE]
  },
  [EPM.ADMIN_OFFERS_PAYOUT]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_OFFERS_PAYOUT_LIST, EP.ADMIN_OFFERS_PAYOUT_GET, EP.ADMIN_OFFERS_PAYOUT_CREATE, EP.ADMIN_OFFERS_PAYOUT_UPDATE, EP.ADMIN_OFFERS_PAYOUT_DELETE]
  },
  [EPM.ADMIN_OFFERS_USERS_GUARANTEES]: {
    original: [EPA.LIST, EPA.CREATE, EPA.APPROVED, EPA.REJECT],
    modified: [EP.ADMIN_OFFERS_USERS_GUARANTEES_LIST, EP.ADMIN_OFFERS_USERS_GUARANTEES_GET, EP.ADMIN_OFFERS_USERS_GUARANTEES_CREATE, EP.ADMIN_OFFERS_USERS_GUARANTEES_UPDATE, EP.ADMIN_OFFERS_USERS_GUARANTEES_DELETE]
  },
  [EPM.ADMIN_GUARANTEES_LOGS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.APPROVED, EPA.REJECT],
    modified: [EP.ADMIN_GUARANTEES_LOGS_LIST, EP.ADMIN_GUARANTEES_LOGS_GET, EP.ADMIN_GUARANTEES_LOGS_CREATE, EP.ADMIN_GUARANTEES_LOGS_UPDATE, EP.ADMIN_GUARANTEES_LOGS_DELETE]
  },
  [EPM.ADMIN_DOMAINS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_DOMAINS_LIST, EP.ADMIN_DOMAINS_GET, EP.ADMIN_DOMAINS_CREATE, EP.ADMIN_DOMAINS_UPDATE, EP.ADMIN_DOMAINS_DELETE]
  },
  [EPM.ADMIN_NEWS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_NEWS_LIST, EP.ADMIN_NEWS_GET, EP.ADMIN_NEWS_CREATE, EP.ADMIN_NEWS_UPDATE, EP.ADMIN_NEWS_DELETE]
  },
  [EPM.ADMIN_LANDINGS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_LANDINGS_LIST, EP.ADMIN_LANDINGS_GET, EP.ADMIN_LANDINGS_CREATE, EP.ADMIN_LANDINGS_UPDATE, EP.ADMIN_LANDINGS_DELETE]
  },
  [EPM.ADMIN_BALANCE]: {
    original: [EPA.LIST, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_BALANCE_LIST, EP.ADMIN_BALANCE_UPDATE, EP.ADMIN_BALANCE_DELETE]
  },
  [EPM.ADMIN_LOGIN_HISTORY]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_LOGIN_HISTORY_LIST]
  },
  [EPM.ADMIN_LOGS]: {
    original: [EPA.QUEUE_EMAIL],
    modified: [EP.ADMIN_LOGS_QUEUE_EMAIL]
  },
  [EPM.ADMIN_PRELANDINGS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_PRELANDINGS_LIST, EP.ADMIN_PRELANDINGS_GET, EP.ADMIN_PRELANDINGS_CREATE, EP.ADMIN_PRELANDINGS_UPDATE, EP.ADMIN_PRELANDINGS_DELETE]
  },
  [EPM.ADMIN_PAYMENTS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.TOTAL, EPA.MASS],
    modified: [EP.ADMIN_PAYMENTS_LIST, EP.ADMIN_PAYMENTS_CREATE, EP.ADMIN_PAYMENTS_UPDATE, EP.ADMIN_PAYMENTS_TOTAL, EP.ADMIN_PAYMENTS_MASS]
  },
  [EPM.ADMIN_TOPUPS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_TOPUPS_LIST, EP.ADMIN_TOPUPS_GET, EP.ADMIN_TOPUPS_CREATE, EP.ADMIN_TOPUPS_UPDATE, EP.ADMIN_TOPUPS_DELETE]
  },
  [EPM.ADMIN_ORDERS]: {
    original: [EPA.LIST, EPA.LOGS, EPA.UPDATE, EPA.COUNTER],
    modified: [EP.ADMIN_ORDERS_LIST, EP.ADMIN_ORDERS_LOGS, EP.ADMIN_ORDERS_UPDATE, EP.ADMIN_ORDERS_COUNTER, EP.ADMIN_ORDERS_VIEW_PHONE]
  },
  [EPM.ADMIN_ORDERS_ERRORS]: {
    original: [EPA.LIST, EPA.GET, EPA.UPDATE, EPA.DELETE, EPA.RESEND],
    modified: [EP.ADMIN_ORDERS_ERRORS_LIST, EP.ADMIN_ORDERS_ERRORS_GET, EP.ADMIN_ORDERS_ERRORS_UPDATE, EP.ADMIN_ORDERS_ERRORS_DELETE, EP.ADMIN_ORDERS_ERRORS_RESEND, EP.ADMIN_ORDERS_ERRORS_VIEW_PHONE]
  },
  [EPM.ADMIN_FAST_LOGIN]: {
    original: [EPA.CREATE, EPA.CHECK],
    modified: [EP.ADMIN_FAST_LOGIN_CREATE, EP.ADMIN_FAST_LOGIN_CHECK]
  },
  [EPM.ADMIN_POSTBACK_LOGS]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_POSTBACK_LOGS_LIST]
  },
  /*  [EPM.ADMIN_PROFILE]: {
     original: [EPA.GET, EPA.UPDATE],
     modified: [EP.ADMIN_PROFILE_GET, EP.ADMIN_PROFILE_UPDATE]
   }, */
  [EPM.ADMIN_COUNTRY]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_COUNTRY_LIST]
  },
  [EPM.ADMIN_DASHBOARD]: {
    original: [EPA.ANALYTICS],
    modified: [EP.ADMIN_DASHBOARD_ANALYTICS]
  },
  [EPM.ADMIN_CHANGELOG]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_CHANGELOG_LIST, EP.ADMIN_CHANGELOG_CREATE, EP.ADMIN_CHANGELOG_UPDATE, EP.ADMIN_CHANGELOG_DELETE]
  },
}
const CPT = constructedPermissionTree

export const adminModules = [
  EPM.ADMIN_REPORT,
  EPM.ADMIN_USERS,
  EPM.ADMIN_USERS_UNAPPROVED,
  EPM.ADMIN_FAST_LOGIN,
  EPM.ADMIN_OFFERS,
  EPM.ADMIN_OFFERS_SUBSCRIPTIONS,
  EPM.ADMIN_OFFERS_ACCESS,
  EPM.ADMIN_OFFERS_BLACKLIST_USERS,
  EPM.ADMIN_OFFERS_PAYOUT,
  EPM.ADMIN_OFFERS_USERS_GUARANTEES,
  EPM.ADMIN_GUARANTEES_LOGS,
  EPM.ADMIN_OFFERS_TRACKING_LINKS,
  EPM.ADMIN_DOMAINS,
  EPM.ADMIN_NEWS,
  EPM.ADMIN_LANDINGS,
  EPM.ADMIN_PRELANDINGS,
  EPM.ADMIN_BALANCE,
  EPM.ADMIN_COUNTRY,
  EPM.ADMIN_LOGIN_HISTORY,
  EPM.ADMIN_LOGS,
  EPM.ADMIN_PAYMENTS,
  EPM.ADMIN_TOPUPS,
  EPM.ADMIN_ORDERS,
  EPM.ADMIN_ORDERS_ERRORS,
  EPM.ADMIN_POSTBACK_LOGS,
  EPM.ADMIN_DASHBOARD,
  EPM.ADMIN_CHANGELOG,
  EPM.ADMIN_PERMISSIONS
]


export const affiliateModules = [
  EPM.AFFILIATE_DOMAINS,
  EPM.AFFILIATE_LOGIN_HISTORY,
  EPM.AFFILIATE_PROFILE,
  EPM.AFFILIATE_PAYMENTS_REQUEST,
  EPM.AFFILIATE_BALANCE,
  EPM.AFFILIATE_REFERRAL,
]

export const advertiserModules = [

]

export const adminActions = [
  ...CPT[EPM.ADMIN_REPORT].modified,
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_USERS_UNAPPROVED].modified,
  ...CPT[EPM.ADMIN_FAST_LOGIN].modified,
  ...CPT[EPM.ADMIN_OFFERS].modified,
  ...CPT[EPM.ADMIN_OFFERS_SUBSCRIPTIONS].modified,
  ...CPT[EPM.ADMIN_OFFERS_ACCESS].modified,
  ...CPT[EPM.ADMIN_OFFERS_BLACKLIST_USERS].modified,
  ...CPT[EPM.ADMIN_OFFERS_TRACKING_LINKS].modified,
  ...CPT[EPM.ADMIN_OFFERS_PAYOUT].modified,
  ...CPT[EPM.ADMIN_OFFERS_USERS_GUARANTEES].modified,
  ...CPT[EPM.ADMIN_GUARANTEES_LOGS].modified,
  ...CPT[EPM.ADMIN_DOMAINS].modified,
  ...CPT[EPM.ADMIN_NEWS].modified,
  ...CPT[EPM.ADMIN_COUNTRY].modified,
  ...CPT[EPM.ADMIN_LANDINGS].modified,
  ...CPT[EPM.ADMIN_PRELANDINGS].modified,
  ...CPT[EPM.ADMIN_LOGIN_HISTORY].modified,
  ...CPT[EPM.ADMIN_LOGS].modified,
  ...CPT[EPM.ADMIN_BALANCE].modified,
  ...CPT[EPM.ADMIN_PAYMENTS].modified,
  ...CPT[EPM.ADMIN_TOPUPS].modified,
  ...CPT[EPM.ADMIN_ORDERS].modified,
  ...CPT[EPM.ADMIN_ORDERS_ERRORS].modified,
  ...CPT[EPM.ADMIN_POSTBACK_LOGS].modified,
  ...CPT[EPM.ADMIN_DASHBOARD].modified,
  ...CPT[EPM.ADMIN_CHANGELOG].modified,
  ...CPT[EPM.ADMIN_PERMISSIONS].modified,
]

export const managerActions = [
  ...CPT[EPM.ADMIN_REPORT].modified,
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_USERS_UNAPPROVED].modified,
  ...CPT[EPM.ADMIN_FAST_LOGIN].modified,
  ...CPT[EPM.ADMIN_OFFERS].modified,
  ...CPT[EPM.ADMIN_OFFERS_SUBSCRIPTIONS].modified,
  ...CPT[EPM.ADMIN_OFFERS_ACCESS].modified,
  ...CPT[EPM.ADMIN_OFFERS_BLACKLIST_USERS].modified,
  ...CPT[EPM.ADMIN_OFFERS_TRACKING_LINKS].modified,
  ...CPT[EPM.ADMIN_OFFERS_PAYOUT].modified,
  ...CPT[EPM.ADMIN_OFFERS_USERS_GUARANTEES].modified,
  ...CPT[EPM.ADMIN_GUARANTEES_LOGS].modified,
  ...CPT[EPM.ADMIN_DOMAINS].modified,
  ...CPT[EPM.ADMIN_NEWS].modified,
  ...CPT[EPM.ADMIN_COUNTRY].modified,
  ...CPT[EPM.ADMIN_LANDINGS].modified,
  ...CPT[EPM.ADMIN_BALANCE].modified,
  ...CPT[EPM.ADMIN_LOGIN_HISTORY].modified,
  ...CPT[EPM.ADMIN_LOGS].modified,
  ...CPT[EPM.ADMIN_PRELANDINGS].modified,
  ...CPT[EPM.ADMIN_PAYMENTS].modified,
  ...CPT[EPM.ADMIN_TOPUPS].modified,
  ...CPT[EPM.ADMIN_ORDERS].modified,
  ...CPT[EPM.ADMIN_ORDERS_ERRORS].modified,
  ...CPT[EPM.ADMIN_POSTBACK_LOGS].modified,
  ...CPT[EPM.ADMIN_PERMISSIONS].modified,
  ...CPT[EPM.ADMIN_DASHBOARD].modified,
  ...CPT[EPM.ADMIN_CHANGELOG].modified,

]

export const affiliateActions = []

export const commonModules = []
export const commonActions = []